import type {
  DynamicLayoutReferenceQueryVariables,
  LayoutListQueryVariables,
  LayoutReferenceQueryVariables,
  MainQueryVariables,
} from '../../graphql/generated/types';

/**
 * Tab 도메인 Query Key 관리
 */
export const LAYOUT_QUERY_KEY_MAP = {
  /**
   * Layout 조회
   */
  layout: (variables?: MainQueryVariables) =>
    variables === undefined ? ['layout'] : ['layout', variables],
  /**
   * Layout List 조회
   */
  layoutList: (variables?: LayoutListQueryVariables) =>
    variables === undefined ? ['layoutList'] : ['layoutList', variables],

  layoutReference: (variables?: LayoutReferenceQueryVariables) =>
    variables === undefined
      ? ['layoutReference']
      : ['layoutReference', variables],

  dynamicLayoutReference: (variables?: DynamicLayoutReferenceQueryVariables) =>
    variables === undefined
      ? ['dynamicLayoutReference']
      : ['dynamicLayoutReference', variables],
} as const;
